export default __webpack_public_path__ + "static/media/task.1789301d.png";